/**
 * Wrapper do app em modo TV.
 * Usa BrowserRouter com basename=/tv e NÃO exige usuário autenticado.
 */
import { Toaster } from 'react-hot-toast';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from '@v2/design-system';
import QueryProvider from './providers/QueryProvider';
import FinanceTvPage from './pages/FinanceTvPage';

export default function TvApp() {
    return (
        <ThemeProvider>
            <QueryProvider>
                <BrowserRouter basename="/tv">
                    <Routes>
                        <Route path="finance" element={<FinanceTvPage tvMode />} />
                        {/* Fallback */}
                        <Route path="*" element={<FinanceTvPage tvMode />} />
                    </Routes>
                </BrowserRouter>
                <Toaster position="top-right" toastOptions={{ className: 'text-sm' }} />
            </QueryProvider>
        </ThemeProvider>
    );
}
